export default function getParameterFromErrorResponse(message) {
  if (!message) return [];
  const parametres = message.split('|')[0].split('@');
  parametres.shift();
  return parametres;
}
